import { createSelector } from 'reselect';
import { RootState } from '../../store/store';

const state = (s: RootState) => s.platformUsers;

const users = createSelector(state, (s) => s.users);
const filteredUsers = createSelector(state, users, (s, list) => {
    const q = s.gridFilter.trim().toLowerCase();
    if (!q) return list;
    return list.filter(
        (u) =>
            u.email?.toLowerCase().includes(q) ||
            u.firstName?.toLowerCase().includes(q) ||
            u.lastName?.toLowerCase().includes(q) ||
            u.companyName?.toLowerCase().includes(q)
    );
});

export const platformUsersSelectors = {
    users,
    filteredUsers,
    total: createSelector(state, (s) => s.total),
    gridFilter: createSelector(state, (s) => s.gridFilter),
    lastError: createSelector(state, (s) => s.lastError)
};
